import { render, staticRenderFns } from "./TopList.vue?vue&type=template&id=7033f3dc&scoped=true&"
import script from "./TopList.vue?vue&type=script&lang=js&"
export * from "./TopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033f3dc",
  null
  
)

export default component.exports